/**
 * Add Configs Index
 * Exports all add configurations and provides getter function
 */

import addBottleConfig from './addBottleConfig';
import addCapConfig from './addCapConfig';
import addLabelConfig from './addLabelConfig';
import addSupplyConfig from './addSupplyConfig';
import addChemicalConfig from './addChemicalConfig';

import addProductConfig from './addProductConfig';

const addConfigs = {
  bottles:   addBottleConfig,
  caps:      addCapConfig,
  labels:    addLabelConfig,
  supplies:  addSupplyConfig,
  chemicals: addChemicalConfig,
  products:  addProductConfig,
};

/**
 * Get add configuration for specific inventory type
 * @param {string} inventoryType - Type of inventory
 * @returns {object} Add configuration
 */
export const getAddConfig = (inventoryType) => {
  const config = addConfigs[inventoryType];
  
  if (!config) {
    throw new Error(`No add configuration found for inventory type: ${inventoryType}`);
  }
  
  return config;
};

/**
 * Check if inventory type has add configuration
 * @param {string} inventoryType - Type of inventory
 * @returns {boolean} True if configuration exists
 */
export const hasAddConfig = (inventoryType) => {
  return !!addConfigs[inventoryType];
};

export {
  addBottleConfig,
  addCapConfig,
  addLabelConfig,
  addSupplyConfig,
  addChemicalConfig,
  addProductConfig
};

export default {
  getAddConfig,
  hasAddConfig,
  addBottleConfig,
  addCapConfig,
  addLabelConfig,
  addSupplyConfig,
  addChemicalConfig,
  addProductConfig
};
